module.exports = __webpack_public_path__ + "img/rcgyysq_zcjj.dd8356bd.png";